export const getUpcomingEvents = (events, now = new Date()) => [...(events || [])]
  .filter(event => {
    const ending = new Date(event.endDateTime || event.startDateTime)
    return !Number.isNaN(ending.getTime()) && ending >= now
  })
  .sort((left, right) => new Date(left.startDateTime) - new Date(right.startDateTime))

export const filterCalendarEvents = (events, query = "", eventType = "all") => {
  const normalizedQuery = query.trim().toLocaleLowerCase()
  return (events || []).filter(event => {
    const kind = event.eventKind === "FellowshipMeet"
      ? "FellowshipMeet"
      : (event.authorityType || "MemberInvitation")
    const searchable = [event.title, event.description, event.location]
      .filter(Boolean)
      .join(" ")
      .toLocaleLowerCase()
    return (eventType === "all" || kind === eventType) &&
      (!normalizedQuery || searchable.includes(normalizedQuery))
  })
}
